<template>
  <div>
    <v-row v-for="n in 8" :key="n">
      <v-col cols="12" class="pt-0">
        <v-skeleton-loader type="list-item"> </v-skeleton-loader>
        <v-divider v-if="n != 8" :key="'d' + n"></v-divider>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-skeleton-loader type="button" class="skeleton-button">
        </v-skeleton-loader>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'k-profil-skeleton',
  data() {
    return {};
  },
  mounted() {},
  created() {},
  methods: {},
  computed: {
    ...mapGetters({}),
  },
  watch: {},
  components: {},
};
</script>
